export const WORKSPACE_WIDTH = 1500;
export const WORKSPACE_HEIGHT = 930;
